import { fromJS } from 'immutable';

export default fromJS({
    periods: [],
    closedUsagePeriods: [],
    periodsUntilCurrent: []
});
